import { render, staticRenderFns } from "./AltaAcuerdo.vue?vue&type=template&id=1335bdef"
import script from "./AltaAcuerdo.vue?vue&type=script&lang=js"
export * from "./AltaAcuerdo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports